import { SQUARE_METERS } from '../../../constants/symbols';

export const formatArea = (area: number): string => {
  return `${area} ${SQUARE_METERS}`;
};
